<template>
  <div>
    <!-- :get-form-data="fromData" -->
    <list row-key="UserId" ref="list" unit="布产" :page="page" :expand-all-row="true" :show-query="true" :query-params="params" :get-data-func="api.list" urlHash="production/clothmanagement/progress">
      <template slot="toolbar-right">
        <slot name="toolbar-right"></slot>
      </template>
      <template slot="table">
        <!-- <el-table-column
          prop="Order"
          label="销售订单号"
          min-width="120"
        ></el-table-column>
        <el-table-column
          prop="SubOrder"
          label="布产单号"
          min-width="120"
        ></el-table-column>
        <el-table-column
          prop="DocTime"
          label="单据日期"
          min-width="120"
        ></el-table-column>
        <el-table-column
          prop="InventoryCode"
          label="存货编码"
          min-width="120"
        ></el-table-column>
        <el-table-column
          prop="InventoryName"
          label="存货名称"
          min-width="120"
        ></el-table-column>
        <el-table-column
          prop="orderProgress"
          label="整单进度"
          min-width="120"
        ></el-table-column> -->
        <slot name="column"></slot>
      </template>
    </list>
  </div>
</template>
<script>
import listMixin from '@/mixins/trend/list'
import list from '@/components/common/trendsTable/list'
import tableColumn from '@/data/production/clothmanagement/progress/list.json'
import tableParam from '@/data/production/clothmanagement/historicalcloth/query.json'

export default {
  mixins: [listMixin],
  components: { list },
  provide() {
    return {
      IsDefaultMonth: false
    }
  },
  data() {
    return {
      api: require('@/api/pr/prProductionProgress').default,

      productApi: require('@/api/ba/product').default,

      params: {
        Order: '',
        OrderProductNo: '',
        CustomerName: '',
        StartDate: '',
        EndDate: '',
        StockName: '',
        Remark: '',
        Department: '',
        Salesman: ''
      }
    }
  },

  methods: {
    edit(row) {
      var loading = this.$loading({
        lock: true,
        text: '正在查询...',
        spinner: 'el-icon-loading',
        customClass: 'my_loading',
        background: 'rgba(0, 0, 0, 0.3)'
      })
      let OrderProductNo = row.OrderProductNo
      this.api.info({ OrderProductNo: OrderProductNo }).then(res => {
        loading.close()
        if (res.Code === 0) {
          console.log('res', res)
        } else {
          this.$message({ type: 'warning', message: res.Msg })
        }
      })
    }
  }
}
</script>
